import { render, staticRenderFns } from "./edit-nutrition-advice-form.vue?vue&type=template&id=4c3ab945&"
import script from "./edit-nutrition-advice-form.vue?vue&type=script&lang=js&"
export * from "./edit-nutrition-advice-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFormLabel: require('@chakra-ui/vue').CFormLabel, CFormControl: require('@chakra-ui/vue').CFormControl, CButton: require('@chakra-ui/vue').CButton, CBox: require('@chakra-ui/vue').CBox})
